export default __webpack_public_path__ + "static/media/M3TRIK.1c58c809.png";